var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 294 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 122.729v58.091h80.727c-3.544 18.682-14.182 34.501-30.137 45.137l48.682 37.774C277.636 237.55 294 199.094 294 153.412c0-10.636-.954-20.864-2.727-30.682L150 122.729z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.934 178.553l-10.98 8.405L16.09 217.23c24.682 48.955 75.27 82.774 133.906 82.774 40.5 0 74.454-13.364 99.273-36.273l-48.682-37.773c-13.364 9-30.41 14.455-50.591 14.455-39 0-72.136-26.318-84-61.774l-.062-.086z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.09 82.773C5.863 102.955 0 125.728 0 150.001c0 24.272 5.863 47.046 16.09 67.227C16.09 217.363 66 178.5 66 178.5c-3-9-4.773-18.545-4.773-28.501S63 130.498 66 121.498L16.09 82.773z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.999 59.728c22.092 0 41.728 7.636 57.41 22.364l42.955-42.955C224.318 14.865 190.5 0 149.999 0 91.363 0 40.772 33.682 16.089 82.774L66 121.502c11.863-35.456 45-61.774 84-61.774z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.66f442411dac23d5e04dd725d5fb526b.svg";
export { ForwardRef as ReactComponent };